<template>
    <div class="container-fluid">
        <div class="row py-3">
            <div class="designRowOrga">
                <div class="h3Organization">
                    <h3 style="letter-spacing: 1px;">Profile</h3>
                </div>
            </div>

            <div class="tabcontent">
                <div class="cardContent col-md-4">
                    <div class="user mb-5">
                        <div class="userIcon">
                            <font-awesome-icon :icon="['fas', 'user']" size="lg" style="color:#e37450"/>
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="userName">
                            {{user.name}}
                        </div>
                    </div>
                    <div class="userE-mail mb-4">
                        <div class="emailUser">
                            <font-awesome-icon :icon="['fas', 'envelope']" size="lg" style="color:#e37450"/>
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="emailWritten">
                            Email
                            <br>
                            {{user.email}}
                        </div>
                    </div>
                    <div class="userPassword">
                        <div class="passwordUser">
                            <font-awesome-icon :icon="['fas', 'lock']" size="lg" style="color:#e37450"/>
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="passwordUserWritten">
                            Password
                            <div class="passwordInfo">
                                <div class="passwordData">
                                    ****************
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <!-- <div class="changePassword">
                                    <router-link :to="'/change-password'">
                                        <a href="javascript:void(0)">Change Password</a>
                                    </router-link>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'profile-page',
        data(){
            return {
                user:{}
            }
        },
        mounted(){
            this.$store.dispatch('activeTap', '');
            this.user = this.$store.state.auth.user.data;
            console.log(this.user);
        },
    }
</script>

<style scoped>
    .passwordInfo .changePassword a{
        color: #e37450;
    }
    .changePassword{
        position: relative;
        bottom: 2px;
    }
    .passwordInfo{
        display: flex;
        flex-direction: row;
    }
    .userPassword{
        display: flex;
        flex-direction: row;
    }
    .userE-mail{
        display: flex;
        flex-direction: row;
    }
    .user .userName{
        color: #e37450;
    }
    .user{
        display: flex;
        flex-direction: row;
    }
    .cardContent{
        border:1px solid var(--border-color-profile-icon);
        padding: 20px;
        border-radius: 10px;
    }
    .designRowOrga{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0;
        margin-bottom: 0;
    }
    .tabcontent {
        border: 1px solid var(--border-color-data-table);;
        border-radius: 20px;
        background-color: var(--border-color-data-table);;
        padding: 23px;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .cardContent{
            width: 50%;
        }
    }

    @media only screen and (max-width: 1170px) and (min-width: 1024px) {
        .cardContent{
            width: 50%;
        }
    }
</style>